export default __webpack_public_path__ + "static/media/Software-Downloading-img2.1ac02a0f.png";